import request from '@/utils/httpRequest'

export default class TztjService {
    queryById (id) {
        return request({
            url: '/shye/report/reportSrycTztj/queryById',
            method: 'get',
            params: {id: id}
        })
    }

	startFlow (params) {
		return request({
		  url: '/shye/report/reportSrycTztj/startFlow',
		  method: 'post',
		  data: params
		})
	}
}
